import styles from "./MinerSection.module.scss";
import cn from "classnames";
import { IMinerSectionProps } from "./MinerSection.props";
import { useMinerSectionControl } from "./useMinerSectionControl";
import { RACK_SECTION_TYPE } from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/Rack.props";

export default function MinerSection(props: IMinerSectionProps) {
  const control = useMinerSectionControl(props);
  return (
    <div
      className={cn(styles.miner, {
        [styles.active]: props.isActive,
        [styles.miner_position]:
          props.item.pos === RACK_SECTION_TYPE.MINER && !control.outOfRange,
        [styles.miner_outOfRange]: control.outOfRange,
      })}
      onClick={props.onClick}
    />
  );
}
